import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getOwnSplitSupplyNotice,
  listOwnSplitSupplyNotices,
  saveOwnSplitSupplyNoticeValues,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_service-SplitSupplyPlanService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 自社の通告値の保存 (表示日の通の全地点の 48 コマ) mutation hook。
 * 成功したら詳細 (更新日時が新しくなる) と一覧 (更新の記録) を最新化する。
 */
export function useSaveOwnSplitSupplyNoticeValues(): InvalidatingMutationResultFor<
  typeof saveOwnSplitSupplyNoticeValues
> {
  return useInvalidatingMutation(saveOwnSplitSupplyNoticeValues, [
    createConnectQueryKey({
      schema: getOwnSplitSupplyNotice,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: listOwnSplitSupplyNotices,
      cardinality: 'finite',
    }),
  ])
}
